/**
 * Standalone Get on the map — Local Carousel Ads (replaces legacy AuctionPage wrapper).
 */
import React from "react";
import LocalCarouselAdsPage from "../facility/LocalCarouselAdsPage";

function StandaloneAdvertisingPage() {
  return <LocalCarouselAdsPage />;
}

export default StandaloneAdvertisingPage;
